import { render } from "./InvestDialog.vue?vue&type=template&id=1a54c5d2&scoped=true"
import script from "./InvestDialog.vue?vue&type=script&lang=js"
export * from "./InvestDialog.vue?vue&type=script&lang=js"

import "./InvestDialog.vue?vue&type=style&index=0&id=1a54c5d2&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a54c5d2"]])

export default __exports__